import { useQuery } from '@tanstack/react-query'
import { hasLiveApi } from '@/api/client'
import { getAllTm, type GetAllTmRow } from '@/api/map/member'
import { isUnreachableApiError } from '@/api/unreachable'
import { keys } from '@/api/hooks/shared/keys'
import { getWorld } from '@/data/world'

function fixtureAllTm(): GetAllTmRow[] {
  return getWorld()
    .accounts.filter((account) => account.role === 'triple-master')
    .map((account) => ({ _id: account.id, username: account.username }))
    .sort((a, b) => a.username.localeCompare(b.username))
}

async function loadAllTm(): Promise<GetAllTmRow[]> {
  if (!hasLiveApi()) return fixtureAllTm()
  try {
    return await getAllTm()
  } catch (error) {
    if (isUnreachableApiError(error)) return []
    throw error
  }
}

/**
 * Triple Masters visible to a Company Master.
 *
 * Agent-API enforces the caller role and hierarchy boundary; `enabled` prevents
 * lower roles from issuing a request they are not allowed to make.
 */
export function useAllTm(enabled: boolean) {
  return useQuery({
    queryKey: keys.allTm,
    queryFn: loadAllTm,
    enabled,
    staleTime: 60_000,
  })
}
